import { render, staticRenderFns } from "./NavigationShop.vue?vue&type=template&id=6b59e01a&"
import script from "./NavigationShop.ts?vue&type=script&lang=ts&"
export * from "./NavigationShop.ts?vue&type=script&lang=ts&"
import style0 from "./NavigationShop.vue?vue&type=style&index=0&lang=vue-scss&"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/atlassian/pipelines/agent/build/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6b59e01a')) {
      api.createRecord('6b59e01a', component.options)
    } else {
      api.reload('6b59e01a', component.options)
    }
    module.hot.accept("./NavigationShop.vue?vue&type=template&id=6b59e01a&", function () {
      api.rerender('6b59e01a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "public/typo3conf/ext/aus_project/Resources/Private/TypeScript/NavigationShop/Components/NavigationShop.vue"
export default component.exports